import { getMassSubLabel } from './priceCalculator';
import { massLabel } from './massCatalog';

// Tittel på et oppdrag, f.eks. «14 tonn grus», «12 tonn pukk 8–16 mm», «9 tonn ren jord» eller «14 tonn jord, bortkjøring».
// For jord erstatter kvaliteten selve ordet («ren jord», «matjord»), så tittelen ikke gjentar seg.
export function massName(order) {
  const mass = (massLabel(order?.massType) ?? '').toLowerCase();
  const sub = getMassSubLabel(order ?? {});
  // Bortkjøring er et tilvalg på massen. Eldre oppdrag har massetypen «removal», som alt heter bortkjøring.
  const removal = order?.removal === true && order.massType !== 'removal' && order.massType !== 'bortkjoring' ? ', bortkjøring' : '';
  if (!sub) return mass + removal;
  if (order.massType === 'soil') return sub.toLowerCase() + removal;
  return `${mass} ${sub}${removal}`;
}

export function orderTitle(order) {
  const unit = order?.unit === 'bags' ? 'sekker' : 'tonn';
  const qty = order?.estimatedTons != null ? `${order.estimatedTons} ${unit} ` : '';
  const container = order?.containerSize > 0 ? `, container ${order.containerSize} m³` : '';
  // Flere lass fra én bestilling er egne ordrer i en gruppe.
  const group = order?.groupSize > 1 && order?.groupIndex >= 1 ? ` · lass ${order.groupIndex} av ${order.groupSize}` : '';
  return `${qty}${massName(order)}${container}${group}`.trim();
}
